import React, { useState } from "react";
import TogglerBody from "../../TogglerBody";
import ChooseActionTamplate from "../../actionTamplate/ChooseActionTamplate";
import CounterTemplate from "./CounterTemplate";
import TipsTamplate from "../../TipsTamplate";
import "./statusTamplate.scss";
import {statusActions} from '../../../../constants/common'

const StatusTemplateAntiRaid = ({ data }) => {
  const [isOnMonitor, setIsOnMonitor] = useState(data?.enabled);
  const [isOnPunish, setIsOnPunish] = useState(data?.applyPunishment);
  const [isUseCustom, setIsUseCustom] = useState(data?.useCustom);
  const [currentAction, setCurrentAction] = useState(data?.punishment || "Kick");

  return (
    <div className="status_block_wrap">
      <div className="status_block_wrap_bg"></div>
      <img
        className="status_block_wrap_img"
        src="/img/StatusBlock.svg"
        alt=""
      />
      <h3>Status</h3>
      <div
        className="status_block_item"
        style={{ borderBottom: "1px solid #8D99A3" }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnMonitor} setIsOn={setIsOnMonitor} keyName={"enabled"} />
          <p>Monitor Spam Activity</p>
        </div>
      </div>
      <div
        className="status_block_item"
        style={{
          borderBottom: "1px solid #8D99A3",
          paddingBottom: "35px",
        }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnPunish} setIsOn={setIsOnPunish} keyName={"applyPunishment"} />
          <p>Apply Global Punishment</p>
          <TipsTamplate
            title={"Global Punishment"}
            label={"Safe"}
            text={
              "<p>Punishment represents what Themis does once this flag is triggered and the total amount of flags accumulated by the member surpasses the limit.</p>"
            }
            textSecond={
              "<p>Punishment type and sensitivity can be override using Advanced Settings.</p>"
            }
          />
        </div>
        <ChooseActionTamplate
          keyName={"punishment"}
          currentAction={currentAction}
          setCurrentAction={setCurrentAction}
          actionArr={statusActions}
        />
      </div>
      <div className="status_block_item">
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isUseCustom} setIsOn={setIsUseCustom} keyName={"useCustom"} />
          <p>Use Custom Parameters</p>
        </div>
      </div>
      
      <div className="status_block_item">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">
            Raid Threshold
          </p> 
        </div>
        <CounterTemplate
          data={{data: data}}
          keyName={"thresholdNumber"}
          keyTime={"thresholdPer"}
          valueTitle="users"
          valueTime={"min"}
          timeType={"min"}
        />
      </div>
      <div className="status_block_item">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">
            Raid Duration
          </p> 
        </div>
        <CounterTemplate
          data={{data: data}}
          keyName={"duration"}
          keyTime={"durationPer"}
          valueTitle=""
          valueTime={"min"}
          timeType={"min"}
        />
      </div>
    </div>
  );
};

export default StatusTemplateAntiRaid;
